import { render, staticRenderFns } from "./non-sticky-nav.vue?vue&type=template&id=f5cc7884&"
import script from "./non-sticky-nav.vue?vue&type=script&lang=js&"
export * from "./non-sticky-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports